module.exports = __webpack_public_path__ + "img/brand.691fe665.svg";